import RecommendationErrorHandler from '../services/Error/RecommendationErrorHandler';
import { CarouselSettingProps } from '../types/common';
import { CAROUSEL_TYPES, TitleKey } from '../utils/constants';

const DEFAULT_CAROUSEL_CONFIG: Omit<CarouselSettingProps, 'titleKey'> = {
  data: RecommendationErrorHandler.getDefaultErrorResponse(),
  seeAllRouterPath: '',
};

const createCarouselConfig = (titleKey: string): CarouselSettingProps => ({
  ...DEFAULT_CAROUSEL_CONFIG,
  titleKey,
});

export const CarouselConfigs: Record<string, CarouselSettingProps> = {
  [CAROUSEL_TYPES.TOP_PICKS]: createCarouselConfig(TitleKey.TOP_PICKS_FOR_YOU),
  [CAROUSEL_TYPES.SEARCH_START_TOP_PICKS]: createCarouselConfig(
    TitleKey.TOP_PICKS_FOR_YOU,
  ),
  [CAROUSEL_TYPES.HOME_RECOMMENDATIONS]: createCarouselConfig(
    TitleKey.RECOMMENDED_FOR_YOU,
  ),
  [CAROUSEL_TYPES.BOUGHTTOGETHER]: {
    ...createCarouselConfig(TitleKey.FREQUENTLY_BOUGHT_TOGETHER),
    carouselIndex: 2,
  },
  [CAROUSEL_TYPES.BRANDS]: {
    ...createCarouselConfig(TitleKey.SIMILAR_PRODUCTS),
    carouselIndex: 0,
  },
  [CAROUSEL_TYPES.CATEGORIES]: {
    ...createCarouselConfig(TitleKey.OTHER_SIMILAR_PRODUCTS),
    carouselIndex: 1,
  },
  [CAROUSEL_TYPES.BASKET_RECOMMENDATION]: createCarouselConfig(
    TitleKey.RECOMMENDED_FOR_YOU,
  ),
  [CAROUSEL_TYPES.FRESH_FOOD_CAROUSEL]: createCarouselConfig(
    TitleKey.FRESH_FOOD_RECOMMENDATIONS,
  ),
  [CAROUSEL_TYPES.ADS_CAROUSEL]: createCarouselConfig(
    TitleKey.HIGHLIGHTED_PRODUCTS,
  ),
};
